import React from 'react';
import CardsPage from '@pages-clean/dummy-page/pages/cards-page';
import FilterListPage from '@pages-clean/dummy-page/pages/filter-list-page';
import TabsPage from '@pages-clean/dummy-page/pages/tabs-page';

interface ControlsPageProps {
    isDisabled: boolean;
}
const LayoutPage = ({ isDisabled }: ControlsPageProps) => {
    return (
        <>
            <h2>Tabs</h2>
            <TabsPage isDisabled={isDisabled} />
            <br />
            <h2>Cards</h2>
            <CardsPage isDisabled={isDisabled} />
            <br />
            <h2>Filter List</h2>
            <FilterListPage />
        </>
    );
};

export default LayoutPage;
